<template>
  <div class="row" >
    <div class="col-24 col-md-17">
      <div class="card card-no mb-3">
        <div class="card-body">
          <div class="d-column flex-row">
            <div
              class="h-form h-profile-lg d-flex flex-column pb-3 align-items-center no"
            >
              <div class="w-100">
                <div class="d-flex align-self-start">
                  <div
                    class="position-relative align-self-center d-flex align-items-center align-self-center"
                  ></div>
                  <div class="pl-3 d-flex">
                    <div class="align-self-start mt-1"></div>
                  </div>
                </div>
                <div class="d-flex align-self-start h-profile">
                  <div class="v-line d-flex align-items-stretch">
                    <span class="pb-4"></span>
                  </div>
                </div>
                <div>
                  <div v-for="(item, index) in programUpdates" :key="index">
                    <div
                      v-if="item.type != 'campaign' && item.type != 'target' && item.type != 'status_program'"
                      class="d-flex align-self-start h-profile-circle"
                    >
                      <div
                        class="circle d-flex justify-content-center flex-row"
                      >
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-success"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3 pl-3">
                        <div class="col-24 pb-2">
                          <div>
                            <span
                              v-text="
                                !item.isProgramCreationDate
                                  ? $utils.formatDataShort(item.createdAt)
                                  : getInitMessage(
                                      $utils.formatDataShort(item.createdAt),
                                    )
                              "
                            />
                            <div
                              v-if="!item.isProgramCreationDate"
                              class="card card-body mx-md-3 d-flex px-3 message-card position-relative"
                            >
                              <svg v-if="item.translated_description != item.description" v-b-tooltip.hover :title="$ml.get('seeOriginalText')" @click="showOriginalDescription = !showOriginalDescription"  width="25" height="25" class="mx-2 icon-description">
                                  <image
                                    xlink:href="../../src/assets/svg/aa.svg"
                                    width="25"
                                    height="25"
                                  />
                              </svg>
                              <div v-show="!showOriginalDescription" v-html="viewHtml(item.translated_description)"></div>
                              <div v-show="showOriginalDescription" v-html="viewHtml(item.description)"></div>
                            </div>
                          </div>
                        </div>
                      </div>               
                    </div>                      
                    <div
                      v-if="item.type === 'status_program'"
                      class="d-flex align-self-start h-profile-circle"
                    >
                      <div
                        class="circle d-flex justify-content-center flex-row"
                      >
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-success"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3 pl-3">
                        <div style="height: 50px;"></div>
                        <div class="col-24 pb-2">
                          <div>
                            <span v-if="item.status === 'paused'">{{ $ml.get('statusPauseProgram')}} <span v-show="userType != 'hacker'">{{ $ml.get('by')}} <strong>{{ item.author }}</strong></span> {{ $ml.get('in')}} {{ $utils.formatDataShort(item.createdAt) }}</span>
                            <span v-else>{{ $ml.get('statusStartProgram')}} <span v-show="userType != 'hacker'">{{ $ml.get('by')}} <strong>{{ item.author }}</strong></span> {{ $ml.get('in')}} {{ $utils.formatDataShort(item.createdAt) }}</span>
                          </div>
                        </div>
                      </div>               
                    </div>
                    <div
                      v-if="item.type == 'campaign' && item.status == 'started'"
                      class="d-flex align-self-start h-profile-circle"
                    >
                      <div
                        class="circle d-flex justify-content-center flex-row"
                      >
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-success"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3 pl-3">
                        <div class="col-24 pb-2">
                          <div>
                            <span
                              v-text="
                                !item.isProgramCreationDate
                                  ? $utils.formatDataShort(item.createdAt)
                                  : getInitMessage(
                                      $utils.formatDataShort(item.createdAt),
                                    )
                              "
                            />
                            <label
                              class="ml-5 mb-5"
                              v-text="$ml.get('campaignStarted')"
                              >{{ item.description }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="item.type == 'campaign' && item.status == 'finished'"
                      class="d-flex align-self-start h-profile-circle"
                    >
                      <div
                        class="circle d-flex justify-content-center flex-row"
                      >
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-success"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3 pl-3">
                        <div class="col-24 pb-2">
                          <div>
                            <span
                              v-text="
                                !item.isProgramCreationDate
                                  ? $utils.formatDataShort(item.createdAt)
                                  : getInitMessage(
                                      $utils.formatDataShort(item.createdAt),
                                    )
                              "
                            />
                            <label
                              class="ml-5 mb-5"
                              v-text="$ml.get('campaignClosed')"
                              >{{ item.description }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div  v-if="item.type == 'campaign' && item.status == 'paused'" 
                      class="d-flex align-self-start h-profile-circle"
                    >
                      <div
                        class="circle d-flex justify-content-center flex-row"
                      >
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-success"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3 pl-3">
                        <div class="col-24 pb-2">
                          <div>
                            <span
                              v-text="
                                !item.isProgramCreationDate
                                  ? $utils.formatDataShort(item.createdAt)
                                  : getInitMessage(
                                      $utils.formatDataShort(item.createdAt),
                                    )
                              "
                            />
                            <label
                              class="ml-5 mb-5"
                              v-text="$ml.get('campaignPause')"
                              >{{ item.description }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="item.type == 'campaign' && item.status == 'resumed'" 
                      class="d-flex align-self-start h-profile-circle"
                    >
                      <div
                        class="circle d-flex justify-content-center flex-row"
                      >
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-success"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3 pl-3">
                        <div class="col-24 pb-2">
                          <div>
                            <span
                              v-text="
                                !item.isProgramCreationDate
                                  ? $utils.formatDataShort(item.createdAt)
                                  : getInitMessage(
                                      $utils.formatDataShort(item.createdAt),
                                    )
                              "
                            />
                            <label
                              class="ml-5 mb-5"
                              v-text="$ml.get('campaignReactivated')"
                              >{{ item.description }}</label
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="item.type === 'target' && item.status === 'finished'"
                      class="d-flex align-self-start h-profile-circle"
                    >
                      <div
                        class="circle d-flex justify-content-center flex-row"
                      >
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-success"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3 pl-3">
                        <div class="col-24 pb-2">
                          <div style="height: 50px;">
                            <span>{{$utils.formatDataShort(item.createdAt)}} - {{$ml.get('target')}} <strong>{{item.target_title}}</strong> {{ $ml.get('achievedIn') }} {{ $ml.get('specialist') }} <strong>{{item.target_hacker}}</strong></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="item.type === 'target' && item.status === 'deleted'"
                      class="d-flex align-self-start h-profile-circle"
                    >
                      <div
                        class="circle d-flex justify-content-center flex-row"
                      >
                        <span
                          class="circle-internal d-flex justify-content-center"
                          ><span class="circle-success"></span
                        ></span>
                        <div class="h-line"><span></span></div>
                        <div class="v-line"><span></span></div>
                      </div>
                      <div class="d-flex flex-column w-100 mr-3 pl-3">
                        <div class="col-24 pb-2">
                          <div style="height: 50px;">
                            <span>{{$utils.formatDataShort(item.createdAt)}} - {{$ml.get('target')}} <strong>{{item.target_title}}</strong> {{ $ml.get('removeIn') }} </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    programUpdates: {
      required: true,
    },
  },
  components: {},
  data() {
    return {
      url: window.location.origin,
      textTolltip: "Copiar link",
      showOriginalDescription: false,
      userType: "",
    };
  },
  methods: {
    viewHtml(message) {
      message = this.$utils.convertMarkedOld(message);
      return message;
    },

    getInitMessage(day) {
      let message = this.$ml.get("initProgramMessage");
      message += day;
      return message;
    },
  },
  created(){
    this.userType = this.$store.getters['getUserType']
    console.log(this.userType)
  }
};
</script>
<style scoped>
.message-card {
  margin-top: 3vh;
  margin-bottom: 3vh;
  width: 55vw;
  max-height: 50vh;
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 9px;
  height: 10px;
  background: rgb(240, 238, 238);
  /* background-color: whitesmoke; */
}

::-webkit-scrollbar-thumb {
  background-color: #aaa;
  /* background: #000; */
  /* background: #730ba9; */
  border-radius: 30px;
}
.icon-description{
  cursor: pointer;
  position: absolute;
  top: 0px;
  right: 0px;
}
</style>
